import { SelectInputWithCustomAdd as AntdSelectInputWithCustomAdd } from "@empglabs/backoffice-ui-kit"

const SelectInputWithCustomAdd = props => {
  return <AntdSelectInputWithCustomAdd {...props} />
}

export default SelectInputWithCustomAdd
